import React from 'react';
import styled from 'styled-components';

export const MessageTypes = {
  ERROR: 'error',
  WARN: 'warn',
  INFO: 'info',
} as const;

export type MessageType = typeof MessageTypes[keyof typeof MessageTypes];

interface MessageDisplayProps {
  type: MessageType;
  children: React.ReactNode;
}

export interface Message {
  type: MessageType;
  message: string;
  field?: string;
}

const MessageDisplay = styled.div<MessageDisplayProps>`
  color: ${props =>
    props.type === MessageTypes.ERROR
      ? '#c02323'
      : props.type === MessageTypes.WARN
      ? '#FFA500'
      : '#ADD8E6'};
`;

export default MessageDisplay;